import { useCallback, useRef, useState } from "react";
import UnsavedChangesDialog from "../components/ui/unsaved-changes-dialog";

export default function useUnsavedChangesGuard(isDirty) {
  const [pendingLeave, setPendingLeave] = useState(false);
  const pendingRef = useRef(null);
  const requestLeave = useCallback((leave) => {
    if (!isDirty) {
      leave?.();
      return;
    }
    pendingRef.current = leave;
    setPendingLeave(true);
  }, [isDirty]);
  const stay = useCallback(() => {
    pendingRef.current = null;
    setPendingLeave(false);
  }, []);
  const discard = useCallback(() => {
    const leave = pendingRef.current;
    pendingRef.current = null;
    setPendingLeave(false);
    leave?.();
  }, []);
  return {
    requestLeave,
    dialog: <UnsavedChangesDialog open={pendingLeave} onStay={stay} onLeave={discard} />,
  };
}
